<template>
    <div>
        <v-flex align-top justify-center>
<!--          <v-data-table :items="startups"></v-data-table>-->
          <div class="d-flex align-center mt-4" style="justify-content: space-between">
            <div class="d-flex align-center" style="width: 300px;flex-grow: 0 !important;">
              <v-btn
                  @click="previousPage"
                  outlined :disabled="this.page === 0"
                  small
                  style="width: 150px; flex-grow: 0 !important; ">
                Previous
              </v-btn>
              <v-btn
                  @click="nextPage"
                  outlined :disabled="this.page >= this.totalPages - 1"
                  small
                  style="width: 150px; flex-grow: 0 !important;">
                Next
              </v-btn>
            </div>
            <p style="width: 150px; flex-grow: 0 !important; text-align: center">Page {{ this.page + 1 }} of {{ this.totalPages }}</p>
              <v-select
                  v-model="size"
                  :items="pageSizes"
                  label="Startups per page"
                  dense
                  outlined
                  style="width: 300px; flex-grow: 0 !important;"
                  @change="onPageSizeChange"
              ></v-select>
          </div>

          <List :elements="startups"
                  :approved="approved"
                  :titleHeader="header"
                  :addNewTitle="addNewStartupTitle"
                  :showCreateButton="showCreateButton"
                  :showExportButton="showExportButton"
                  :exportCallback="exportStartup"
                  :createCallback="navigateCreate"
                  :clickCallback="navigate"
                  :deleteCallback="openDeleteStartupDialog"
                  @startup-page="resetPage"
                  @startup-search="findStartups">

          </List>
        </v-flex>



<!--       Bottoni di navigazione tra le pagine
      <v-row justify="center" class="mt-4">
        <v-btn @click="previousPage" :disabled="page === 0">Previous</v-btn>
        <span class="mx-3">Page {{ page + 1 }} of {{ totalPages }}</span>
        <v-btn @click="nextPage" :disabled="page === totalPages - 1">Next</v-btn>
      </v-row>-->

        <v-dialog
                v-model="deleteStartupDialog"
                max-width="650"
                persistent
        >
            <v-card>
                <v-card-title class="headline">Deleting {{ selectedStartup.nameToShow}} </v-card-title>
                <v-card-text>
                    Are you sure?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            flat="flat"
                            @click="closeDeleteStartupDialog()"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                            color="red"
                            flat="flat"
                            @click="deleteStartup()"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>


</template>

<script>
    import RouterService from "@/helpers/RouterService";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import UrlsService from "@/helpers/UrlsService";
    import List from "@/components/Lists/List";
    import ExcelJS from 'exceljs';
    import FileSaver from 'file-saver';
    import {mapGetters,mapState} from "vuex";


    export default {
        name: "StartupList",
        components: {List},
        props: {
            approved: Number,
        },
        data() {
            return {
                page: 0,
                size: 50,
                totalPages: 0,
                pageSizes: [
                    { text: "10", value: 10 },
                    { text: "50", value: 50 },
                    { text: "100", value: 100 },
                    { text: "All", value: -1 } ],
                showCreateButton: this.approved === 1 ? true : false,
                showExportButton: this.approved === 1 ? true : false,
                header: "Startups",
                addNewStartupTitle: "Add new",
                startups: [],
                completeStartups: [],
                selectedStartup: {},
                tagsSuggestion:[],
                deleteStartupDialog: false,
                search: '',
                name: '',
            }
        },
        created() {
            this.findStartups(this.name);
        },
        computed: {
            ...mapState({}),
            ...mapGetters('UserState', {
                    userInfo: 'getUserInfo',
                }
            ),
        },
        methods: {
            onPageSizeChange(newSize) {
              this.size = newSize;
              this.page = 0; // Torna alla prima pagina
              this.findStartups(this.name); // Ricarica i dati con la nuova dimensione
            },
            previousPage() {
              if (this.page > 0) {
                this.page--;
                this.findStartups(this.name); // Ricarica i dati per la nuova pagina
              }
            },
            nextPage() {
              if (this.page < this.totalPages - 1) {
                console.log("pagine: ", this.page);
                this.page++;
                this.findStartups(this.name); // Ricarica i dati per la nuova pagina
              }
            },
            exportStartup(){
                let workbook = new ExcelJS.Workbook();
                let sheet = workbook.addWorksheet('Startups');
                let keys =  Object.keys(this.completeStartups[0]);
                let columns = [];
              columns.push({header: "Startup Name", key: "Name", width: 25});
              columns.push({header: "Country", key: "Country", width: 25});
              columns.push({header: "Region / City", key: "Region / city", width: 25}); // Modificato da "Region / city"
              columns.push({header: "Area", key: "Area", width: 25});
              columns.push({header: "Vertical solution", key: "Vertical solution (if any)", width: 25}); // Extra dalla lista da controllare       
              columns.push({header: "Idea state", key: "Idea state", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Contact name", key: "Contact name", width: 25});
              columns.push({header: "Email Address", key: "Contact details", width: 25}); // Modificato da "Contact details"
              columns.push({header: "Patent available", key: "Patent", width: 25});
              columns.push({header: "SDK/API", key: "SDK/API", width: 25});
              columns.push({header: "Existing Partnerships/Exclusivity (non-VC's)", key: "Existing Partnerships/Exclusivity (non-VC's)", width: 25});
              columns.push({header: "Business model", key: "Business model", width: 25});
              columns.push({header: "Website", key: "Website", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Tags", key: "Tags", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Mobile phone", key: "Mobile phone", width: 25});
              columns.push({header: "Company LinkedIn URL", key: "Contact links", width: 25});
              columns.push({header: "Contact address", key: "Contact address", width: 25});
              columns.push({header: "Logo", key: "Logo", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Crunchbase link", key: "Crunchbase link", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Fundings amount", key: "Fundings amount", width: 25});
              columns.push({header: "Fundings date", key: "Fundings date", width: 25});
              columns.push({header: "Fundings investors", key: "Fundings investors", width: 25});
              columns.push({header: "Valuation", key: "Valuation", width: 25});
              columns.push({header: "Competitors", key: "Competitors", width: 25});
              columns.push({header: "Foundation", key: "Foundation", width: 25});
              columns.push({header: "Number Employees", key: "NumberEmployees", width: 25})
              columns.push({header: "URL Video", key: "UrlVideo", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Idea description-EN", key: "Idea description-EN", width: 60}); // Extra dalla lista da controllare
              columns.push({header: "Idea description-IT", key: "Idea description-IT", width: 60}); // Extra dalla lista da controllare
              columns.push({header: "State of contact", key: "State of contact", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Addressed Market", key: "Addressed MU", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Technology area", key: "Technology area", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Replication complexity", key: "Replication complexity", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Deployment complexity", key: "Deployment complexity", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Technological footprint", key: "Technological footprint", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Extensive business enabler", key: "Extensive business enabler", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Funding status", key: "Funding status (CrunchBase)", width: 25}); // Modificato da "Funding status (CrunchBase)"
              columns.push({header: "Financial status", key: "Financial status (Startuplus, iCRIBIS)", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Opportunities", key: "Opportunities", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "NTT DATA SPOC", key: "BSL/MU contact", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Project state", key: "Project state (if any)", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Battlecard available", key: "Battlecard available", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Agreement", key: "Agreement", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Evaluation date", key: "Evaluation date", width: 25});
              columns.push({header: "Link to folder in Peers", key: "Link to folder in Peers", width: 60}); // Extra dalla lista da controllare
              columns.push({header: "OpCo", key: "OpCo", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Sustainability Goals", key: "SustainabilityGoals", width: 25}); // Modificato da "SustainabilityGoals"
              columns.push({header: "NTT E/G/M Themes", key: "NTT E/G/M", width: 25});
              columns.push({header: "Regions Served", key: "RegionZone", width: 25});
              columns.push({header: "Source", key: "Source", width: 25});
              columns.push({header: "_id", key: "_id", hidden: true});
              columns.push({header: "token", key: "token", hidden: true});
              columns.push({header: "Score", key: "Score", width: 25}); // Extra dalla lista da controllare
              columns.push({header: "Data Added", key: "Date Added", width: 25});
              columns.push({header: "NTT Lead Opco", key: "NTT Lead Opco", width: 25});
              columns.push({header: "Notes/Comments", key: "Notes/Comments", width: 25});

                /*for (let i = 0; i<keys.length; i++){
                    if(keys[i] === "_id" || keys[i] === "token"){
                        columns.push({header: keys[i], key: keys[i], hidden: true})
                    }
                    else if (keys[i] === "Idea description-EN" || keys[i] === "Idea description-IT" || keys[i] === "Link to folder in Peers"){
                        columns.push({header: keys[i], key: keys[i], width: 60})
                    }
                    else {
                        columns.push({header: keys[i], key: keys[i], width: 25})
                    }

                }*/
                sheet.columns = columns;
                for (let j = 0; j<this.completeStartups.length; j++){
                    if(this.completeStartups[j]["approved"]===this.approved) {
                        /*let date = this.completeStartups[j]["Evaluation date"];
                    if(date !== "None"){
                        let parts = date.split("-");
                        if (parts[1].length === 1) {parts[1] = "0" + parts[1];}
                        this.completeStartups[j]["Evaluation date"] = parts[2] + "-" + parts[1];
                    }*/
                        if(this.completeStartups[j]['Tags'] != undefined && (this.completeStartups[j]['Tags'] instanceof Array)){
                            let tagString ="";
                            for(let z=0;z<this.completeStartups[j]['Tags'].length;z++){
                                tagString = tagString.concat(this.completeStartups[j]['Tags'][z])
                                if(z<this.completeStartups[j]['Tags'].length-1){
                                    tagString = tagString.concat(",")
                                }
                            }
                            this.completeStartups[j]['Tags'] = tagString
                        }

                      if(this.completeStartups[j]['SustainabilityGoals'] != undefined && (this.completeStartups[j]['SustainabilityGoals'] instanceof Array) ){
                        let GoalsString ="";
                        for(let z=0;z<this.completeStartups[j]['SustainabilityGoals'].length;z++){
                          GoalsString = GoalsString.concat(this.completeStartups[j]['SustainabilityGoals'][z])
                          if(z<this.completeStartups[j]['SustainabilityGoals'].length-1){
                            GoalsString = GoalsString.concat(",")
                          }
                        }
                        this.completeStartups[j]['SustainabilityGoals'] = GoalsString
                      }
                      else if (this.completeStartups[j]['SustainabilityGoals'] == undefined) {
                        this.completeStartups[j]['SustainabilityGoals'] = ""
                      }

                        this.completeStartups[j]['Score'] = parseFloat(this.completeStartups[j]['Score'])
                        if (this.completeStartups[j]['Mobile phone'] !== undefined) this.completeStartups[j]['Mobile phone'] = this.completeStartups[j]['Mobile phone'].toString()
                        sheet.addRow(this.completeStartups[j]);
                    }
                }

                sheet.getRow(1).font = {size: 12, bold: true, color: {argb: 'FFFFFFFF'}};
                sheet.getRow(1).eachCell(function(cell, colNumber) {
                        cell.fill = {
                            type: 'pattern',
                            pattern:'solid',
                            fgColor:{argb:'FF4169E1'},
                            bgColor:{argb:'FF4169E1'}
                        };
                    }
                )

                let borderStyles = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };

                sheet.eachRow({ includeEmpty: true },function(row, rowNumber) {
                    row.eachCell(function(cell, colNumber) {
                        cell.border = borderStyles;
                        cell.alignment = { wrapText: true };
                    });
                });

                workbook.xlsx.writeBuffer()
                    .then(buffer => FileSaver.saveAs(new Blob([buffer]), `Startups_discovery.xlsx`))
                    .catch(err => console.log('Error writing excel export', err))

            },
            navigate(startup) {
                let path = {
                    name: "StartupInfo",
                    params: {
                        //approved: this.approved,
                        startupId: startup.id,
                        //startupName: startup.nameToShow,
                    },
                };
                RouterService.goTo(path);
            },
            navigateCreate(startup) {
                let path = {
                    name: "StartupInfo",
                    params: {
                        startupId: "newStartup",
                        startupName: "",
                    },
                };
                RouterService.goTo(path);
            },
            openDeleteStartupDialog(startup) {
                this.selectedStartup = startup;
                this.deleteStartupDialog = true;
            },
            closeDeleteStartupDialog() {
                this.selectedStartup = {};
                this.deleteStartupDialog = false;
            },
            deleteStartup() {
                let startup = {
                    _id:this.selectedStartup.id,
                    Name: this.selectedStartup.nameToShow
                }
                let requestUrl = {
                    url: this.userInfo.role === "APPROVER_INNOVATION" ? UrlsService.deleteStartup : UrlsService.startupOperationProposal,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "DELETE",
                        startupRequest:{
                            startup:startup
                        }
                    },
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: this.userInfo.role === "APPROVER_INNOVATION" ? "Startup deleted" : "Startup delete proposal. Wait until Approver verify your delete request.",
                      loading: "Waiting for startup management operation...",
                      error: "Cannot complete startup management operation...",
                };
                let options = {
                    loadingType: "fullscreen+notification",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        this.deleteStartupDialog = false;
                        this.findStartups(this.name);
                    });
            },
            getStartups() {
                let requestUrl = {
                    url: UrlsService.getStartups,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                    },
                    approved: this.approved
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "List Startups",
                    loading: "Waiting for list of startups...",
                    error: "Cannot get startups...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        //this.startups = [];
                        this.completeStartups = [];
                        let responseStartups = responseSuccess.response.startups;
                        this.completeStartups = responseStartups;
                        //this.totalPages = responseSuccess.response.totalPages;
                        /*if(responseStartups != undefined){
                            for (let i = 0; i < responseStartups.length; i++) {
                            if(responseStartups[i]["approved"]===this.approved){
                                this.startups.push({
                                    id: responseStartups[i]["_id"],
                                    nameToShow: responseStartups[i].Name,
                                    email: responseStartups[i]["Contact details"],
                                });
                                if (i !== responseStartups.length - 1) {
                                    this.startups.push({divider: true, inset: false,});
                                }
                            }

                        }}*/

                    });
                return requestData;
            },
            findStartups(name) {
              this.name = name;
              let requestUrl = {
                url: UrlsService.findStartups,
                timeout: TimeService.secondsToMillis(0),
              };
              let requestData = {
                interactionData: {
                },
                page: this.page,
                size: this.size,
                name: this.name,
                approved: this.approved
              };
              let requestObject = {
                type: "normal",
                urlsInfo: requestUrl,
                data: {
                  data: requestData,
                },
              };
              let messages = {
                title: "List Startups",
                loading: "Waiting for list of startups...",
                error: "Cannot get startups...",
              };
              let options = {
                loadingType: "fullscreen",
                timeout: TimeService.secondsToMillis(0),
              };
              APILoaderDecoratorService.setLoader(requestObject, messages, options)
                  .then(responseSuccess => {
                    this.startups = [];
                    this.completeStartups = [];
                    let responseStartups = responseSuccess.response.startups;
                    this.completeStartups = responseStartups;
                    this.totalPages = responseSuccess.response.totalPages;
                    if(responseStartups != undefined){
                      for (let i = 0; i < responseStartups.length; i++) {
                        if(responseStartups[i]["approved"]===this.approved){
                          this.startups.push({
                            id: responseStartups[i]["_id"],
                            nameToShow: responseStartups[i].Name,
                            email: responseStartups[i]["Contact details"],
                          });
                          if (i !== responseStartups.length - 1) {
                            this.startups.push({divider: true, inset: false,});
                          }
                        }

                      }}

                  });
            },
            resetPage(initialPage) {
              this.page = initialPage
            }
        }
    }
</script>

<style scoped>

</style>
